module.exports = __webpack_public_path__ + "static/media/save-svgrepo-com (5).425289ca.svg";